import { Transform } from 'class-transformer';
import { isNil } from 'lodash';
import { Types } from 'mongoose';

export const ToObjectId = () =>
  Transform(({ value }) => {
    if (Array.isArray(value)) return value.map((item) => (isNil(item) || !Types.ObjectId.isValid(item) ? value : new Types.ObjectId(item)));
    return isNil(value) || !Types.ObjectId.isValid(value) ? value : new Types.ObjectId(value);
  });
